/**
 * @generated SignedSource<<42422035b1f25817a786ce111ad22747>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type ZnglistTemplateTypeEnum = "CLASSIC" | "PENDING" | "PERSONAL";
export type ZnglistUserTypeEnum = "ADMIN" | "USER";
export type DuplicateZnglistInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  node?: CreateZnglistInput | null | undefined;
};
export type CreateZnglistInput = {
  authorId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  date?: string | null | undefined;
  formId?: string | null | undefined;
  menuOrder?: number | null | undefined;
  order?: number | null | undefined;
  password?: string | null | undefined;
  slug?: string | null | undefined;
  status?: PostStatusEnum | null | undefined;
  statusSettings?: StatusSettingsInput | null | undefined;
  templateType?: ZnglistTemplateTypeEnum | null | undefined;
  title?: string | null | undefined;
  userType?: ZnglistUserTypeEnum | null | undefined;
  znglyContents?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type StatusSettingsInput = {
  approved?: ApprovedStateInput | null | undefined;
  stateWhenApproved?: StateWhenApprovedInput | null | undefined;
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type ApprovedStateInput = {
  id?: string | null | undefined;
};
export type StateWhenApprovedInput = {
  status?: PostStatusEnum | null | undefined;
  uiPermission?: UIPermissionInput | null | undefined;
};
export type UIPermissionInput = {
  type?: StatusUiPermissionEnum | null | undefined;
};
export type Znglist_Duplicate_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: DuplicateZnglistInput;
};
export type Znglist_Duplicate_Mutation$data = {
  readonly duplicateZnglist: {
    readonly znglist: {
      readonly author: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly id: string;
      readonly link: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly status: string | null | undefined;
      readonly statusSettings: {
        readonly approved: {
          readonly id: string | null | undefined;
          readonly timestamp: string | null | undefined;
          readonly user: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly stateWhenApproved: {
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly status: PostStatusEnum | null | undefined;
        readonly uiPermission: {
          readonly type: StatusUiPermissionEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly title: string | null | undefined;
      readonly znglist: {
        readonly form: {
          readonly node: {
            readonly content: string | null | undefined;
            readonly id: string;
            readonly imageUrl: string | null | undefined;
            readonly marketingConsent: boolean | null | undefined;
            readonly metadata: {
              readonly cookieExpiration: string | null | undefined;
              readonly formStyle: FormMetadataStyleEnum | null | undefined;
              readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
              readonly submitSuccessText: string | null | undefined;
            } | null | undefined;
            readonly password: boolean | null | undefined;
            readonly schema: string | null | undefined;
            readonly title: string;
            readonly uiSchema: string | null | undefined;
          };
        } | null | undefined;
        readonly order: number | null | undefined;
        readonly templateType: string | null | undefined;
        readonly userType: string | null | undefined;
        readonly znglyContents: ReadonlyArray<{
          readonly author?: {
            readonly node: {
              readonly id: string;
              readonly name: string | null | undefined;
              readonly slug: string | null | undefined;
              readonly username: string | null | undefined;
            };
          } | null | undefined;
          readonly databaseId?: number;
          readonly id?: string;
          readonly link?: string | null | undefined;
          readonly searchResults?: {
            readonly extractiveAnswers: ReadonlyArray<{
              readonly content: string | null | undefined;
              readonly pageNumber: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly snippets: ReadonlyArray<{
              readonly snippet: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status?: string | null | undefined;
          readonly statusSettings?: {
            readonly approved: {
              readonly id: string | null | undefined;
              readonly timestamp: string | null | undefined;
              readonly user: {
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly stateWhenApproved: {
              readonly status: PostStatusEnum | null | undefined;
              readonly uiPermission: {
                readonly type: StatusUiPermissionEnum | null | undefined;
              } | null | undefined;
            } | null | undefined;
            readonly status: PostStatusEnum | null | undefined;
            readonly uiPermission: {
              readonly type: StatusUiPermissionEnum | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly title?: string | null | undefined;
          readonly znglyContent?: {
            readonly aiSummary: string | null | undefined;
            readonly contentEmbedHtml: string | null | undefined;
            readonly contentFile: {
              readonly description: string | null | undefined;
              readonly mediaDetails: {
                readonly sizes: ReadonlyArray<{
                  readonly name: string | null | undefined;
                  readonly sourceUrl: string | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly mediaItemUrl: string | null | undefined;
              readonly mimeType: string | null | undefined;
            } | null | undefined;
            readonly contentLink: string | null | undefined;
            readonly contentMediaName: string | null | undefined;
            readonly contentMediaType: string | null | undefined;
            readonly ctaLink: string | null | undefined;
            readonly ctaName: string | null | undefined;
            readonly featuredImageFile: {
              readonly description: string | null | undefined;
              readonly mediaDetails: {
                readonly sizes: ReadonlyArray<{
                  readonly name: string | null | undefined;
                  readonly sourceUrl: string | null | undefined;
                } | null | undefined> | null | undefined;
              } | null | undefined;
              readonly mediaItemUrl: string | null | undefined;
              readonly mimeType: string | null | undefined;
            } | null | undefined;
            readonly featuredImageLink: string | null | undefined;
            readonly form: {
              readonly node: {
                readonly content: string | null | undefined;
                readonly id: string;
                readonly imageUrl: string | null | undefined;
                readonly marketingConsent: boolean | null | undefined;
                readonly metadata: {
                  readonly cookieExpiration: string | null | undefined;
                  readonly formStyle: FormMetadataStyleEnum | null | undefined;
                  readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
                  readonly submitSuccessText: string | null | undefined;
                } | null | undefined;
                readonly password: boolean | null | undefined;
                readonly schema: string | null | undefined;
                readonly title: string;
                readonly uiSchema: string | null | undefined;
              };
            } | null | undefined;
            readonly htmlDesc: string | null | undefined;
            readonly shortText: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Znglist_Duplicate_Mutation = {
  response: Znglist_Duplicate_Mutation$data;
  variables: Znglist_Duplicate_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "StateWhenApproved",
  "kind": "LinkedField",
  "name": "stateWhenApproved",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "AiSearchResults",
  "kind": "LinkedField",
  "name": "searchResults",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Snippet",
      "kind": "LinkedField",
      "name": "snippets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "snippet",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtractiveAnswer",
      "kind": "LinkedField",
      "name": "extractiveAnswers",
      "plural": true,
      "selections": [
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiSummary",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaLink",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaType",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentLink",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentEmbedHtml",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentMediaName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v31 = [
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featuredImageLink",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortText",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "htmlDesc",
  "storageKey": null
},
v35 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v7/*: any*/),
      (v18/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
  "kind": "LinkedField",
  "name": "form",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Znglist_ZnglistToFormConnectionEdge",
  "kind": "LinkedField",
  "name": "form",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v12/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = [
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Znglist_Duplicate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DuplicateZnglistPayload",
        "kind": "LinkedField",
        "name": "duplicateZnglist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist",
            "kind": "LinkedField",
            "name": "znglist",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Znglist_Znglist",
                "kind": "LinkedField",
                "name": "znglist",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "znglyContents",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v17/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v13/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ZnglyVideo_Znglycontent",
                            "kind": "LinkedField",
                            "name": "znglyContent",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaItem",
                                "kind": "LinkedField",
                                "name": "contentFile",
                                "plural": false,
                                "selections": (v31/*: any*/),
                                "storageKey": null
                              },
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaItem",
                                "kind": "LinkedField",
                                "name": "featuredImageFile",
                                "plural": false,
                                "selections": (v31/*: any*/),
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ZnglyVideo",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Znglist_Duplicate_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DuplicateZnglistPayload",
        "kind": "LinkedField",
        "name": "duplicateZnglist",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Znglist",
            "kind": "LinkedField",
            "name": "znglist",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v5/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Znglist_Znglist",
                "kind": "LinkedField",
                "name": "znglist",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "znglyContents",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v17/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v38/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ZnglyVideo_Znglycontent",
                            "kind": "LinkedField",
                            "name": "znglyContent",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaItem",
                                "kind": "LinkedField",
                                "name": "contentFile",
                                "plural": false,
                                "selections": (v39/*: any*/),
                                "storageKey": null
                              },
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaItem",
                                "kind": "LinkedField",
                                "name": "featuredImageFile",
                                "plural": false,
                                "selections": (v39/*: any*/),
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ZnglyVideo",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "znglist",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Znglist"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4ba66970077454cd1623992d4df6a3a6",
    "id": null,
    "metadata": {},
    "name": "Znglist_Duplicate_Mutation",
    "operationKind": "mutation",
    "text": "mutation Znglist_Duplicate_Mutation(\n  $input: DuplicateZnglistInput!\n) {\n  duplicateZnglist(input: $input) {\n    znglist {\n      id\n      author {\n        node {\n          id\n          name\n          username\n          slug\n        }\n      }\n      title\n      link\n      status\n      slug\n      statusSettings {\n        status\n        uiPermission {\n          type\n        }\n        stateWhenApproved {\n          status\n          uiPermission {\n            type\n          }\n        }\n        approved {\n          id\n          timestamp\n          user {\n            name\n            id\n          }\n        }\n      }\n      znglist {\n        order\n        userType\n        templateType\n        znglyContents {\n          __typename\n          ... on ZnglyVideo {\n            id\n            databaseId\n            author {\n              node {\n                id\n                name\n                username\n                slug\n              }\n            }\n            title\n            link\n            status\n            statusSettings {\n              status\n              uiPermission {\n                type\n              }\n              stateWhenApproved {\n                status\n                uiPermission {\n                  type\n                }\n              }\n              approved {\n                id\n                timestamp\n                user {\n                  name\n                  id\n                }\n              }\n            }\n            searchResults {\n              snippets {\n                snippet\n              }\n              extractiveAnswers {\n                content\n                pageNumber\n              }\n            }\n            znglyContent {\n              aiSummary\n              ctaLink\n              ctaName\n              contentMediaType\n              contentLink\n              contentEmbedHtml\n              contentMediaName\n              contentFile {\n                mediaItemUrl\n                mimeType\n                mediaDetails {\n                  sizes {\n                    sourceUrl\n                    name\n                  }\n                }\n                description\n                id\n              }\n              featuredImageLink\n              featuredImageFile {\n                mediaItemUrl\n                mimeType\n                mediaDetails {\n                  sizes {\n                    sourceUrl\n                    name\n                  }\n                }\n                description\n                id\n              }\n              shortText\n              htmlDesc\n              form {\n                node {\n                  id\n                  title\n                  content\n                  schema\n                  uiSchema\n                  metadata {\n                    formStyle\n                    formTemplate\n                    cookieExpiration\n                    submitSuccessText\n                  }\n                  marketingConsent\n                  password\n                  imageUrl\n                }\n              }\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        form {\n          node {\n            id\n            title\n            content\n            schema\n            uiSchema\n            metadata {\n              formStyle\n              formTemplate\n              cookieExpiration\n              submitSuccessText\n            }\n            marketingConsent\n            password\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a9016a53fe0e4a43241014367939e5f";

export default node;
